<template>
  <QItem clickable @click="handleAction">
    <QItemSection avatar>
      <QIcon :name="icon" :color="iconColor" />
    </QItemSection>
    <QItemSection>{{ label }}</QItemSection>
  </QItem>
</template>

<script setup>
  const emit = defineEmits(["on-action"]);

  const props = defineProps({
    icon: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      default: "faded",
    },
    label: {
      type: String,
      required: true,
    },
  });

  const handleAction = () => {
    emit("on-action");
  };
</script>
